<form [formGroup]="formGroup">
  <div mat-dialog-title>
    <h2>{{ 'dialog.waitlist.title' | translate }}</h2>
  </div>

  <mat-dialog-content>
    <h5>
      <ng-container *ngIf="data.appointment.waitList; else addWaitlistEl">
        {{ 'dialog.waitlist.remove-subtitle' | translate }}
      </ng-container>
      <ng-template #addWaitlistEl>
        {{ 'dialog.waitlist.add-subtitle' | translate }}
      </ng-template>
    </h5>
    <p>{{ 'dialog.waitlist.description' | translate }}</p>

    <div fxLayout="column">
      <mat-form-field fxFlex>
        <mat-label>
          {{ 'dialog.waitlist.patient-form.locations' | translate }}
        </mat-label>
        <mat-select multiple formControlName="locations">
          <mat-option
            *ngFor="let location of locations$ | async"
            [value]="location.id"
          >
            {{ location.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div fxFlex>
        <p>{{ 'dialog.waitlist.time' | translate }}</p>

        <mmx-availability-picker
          [locationsOpen]="locationsOpen$ | async"
          formControlName="weekdays"
        ></mmx-availability-picker>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-stroked-button type="button" mat-dialog-close>
      {{ 'common.cancel' | translate }}
    </button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="formGroup.invalid"
      (click)="onSubmit()"
    >
      <ng-container *ngIf="data.appointment.waitList; else saveAddWaitlistEl">
        {{ 'common.update' | translate }}
      </ng-container>
      <ng-template #saveAddWaitlistEl>
        {{ 'dialog.waitlist.save-add' | translate }}
      </ng-template>
    </button>
  </mat-dialog-actions>
</form>
